import { Box, Button, Chip, Typography } from '@mui/material';

export interface SuggestionRowProps {
  label: string;
  value: string;
  color: string;
  alreadyAdded: boolean;
  onAdd: () => void;
  onRemove: () => void;
}

export function SuggestionRow({ label, value, color, alreadyAdded, onAdd, onRemove }: SuggestionRowProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
      <Chip label={label} size="small" sx={{ bgcolor: `${color}20`, color }} />
      <Typography variant="body2" sx={{ flex: 1 }}>{value}</Typography>
      {alreadyAdded ? (
        <Button size="small" variant="outlined" color="error" onClick={onRemove}>
          Retirer
        </Button>
      ) : (
        <Button size="small" variant="outlined" onClick={onAdd}>
          Ajouter
        </Button>
      )}
    </Box>
  );
}
